import { getMedicalHistoryResponseFormat } from './promptFormatSpecs'
import { AgentIngressPromptType, type IngressContextKey } from './types'

export interface PromptContext {
  clientId?: string
  patientId?: string
  patientName?: string
}

export interface PromptTemplate {
  buildPrompt: (context: PromptContext) => string
  requiredContext: IngressContextKey[]
  type: AgentIngressPromptType
  validateContext?: (context: PromptContext) => boolean
}

export const PROMPT_TEMPLATES: Record<AgentIngressPromptType, PromptTemplate> =
  {
    [AgentIngressPromptType.PATIENT_SUMMARY]: {
      type: AgentIngressPromptType.PATIENT_SUMMARY,
      requiredContext: ['patientId'],
      buildPrompt: ({ patientName, patientId }) =>
        `Summarize patient ${patientName || 'this patient'} <!--(ID: ${patientId})-->for me.`,
    },
    [AgentIngressPromptType.COMMUNICATION_HISTORY]: {
      type: AgentIngressPromptType.COMMUNICATION_HISTORY,
      requiredContext: ['patientId'],
      buildPrompt: ({ patientName, patientId }) =>
        `Show me the communication history for patient ${patientName || 'this patient'}<!--(ID: ${patientId})-->.`,
    },
    [AgentIngressPromptType.MEDICAL_HISTORY]: {
      type: AgentIngressPromptType.MEDICAL_HISTORY,
      requiredContext: ['patientId'],
      buildPrompt: ({ patientName, patientId }) =>
        `Show me the medical history for patient ${patientName || 'this patient'}<!--(ID: ${patientId})-->.\n\n${getMedicalHistoryResponseFormat(patientName || 'this patient')}`,
    },
    [AgentIngressPromptType.OVERDUE_ITEMS]: {
      type: AgentIngressPromptType.OVERDUE_ITEMS,
      requiredContext: ['patientId'],
      buildPrompt: ({ patientName, patientId }) =>
        `What are the overdue items for patient ${patientName || 'this patient'}<!--(ID: ${patientId})-->?`,
    },
  }

export const DEFAULT_PROMPT_TYPE = AgentIngressPromptType.PATIENT_SUMMARY
